module.exports = __webpack_public_path__ + "img/1.84845fb2.png";